import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function ImageCarousel({ images = [], alt = "" }) {
  const [i, setI] = useState(0);
  const list = images.filter(Boolean);
  if (list.length === 0) return null;

  const go = (dir) => setI((prev) => (prev + dir + list.length) % list.length);

  return (
    <div data-testid="image-carousel" className="relative border border-darkgrey/30 bg-paper select-none">
      <img src={list[i]} alt={`${alt} ${i + 1}`} className="w-full object-contain" />

      {list.length > 1 && (
        <>
          <button
            type="button"
            data-testid="carousel-prev"
            onClick={() => go(-1)}
            aria-label="Immagine precedente"
            className="absolute left-3 top-1/2 -translate-y-1/2 bg-ink/85 text-greige p-2.5 hover:bg-ink transition-colors"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            type="button"
            data-testid="carousel-next"
            onClick={() => go(1)}
            aria-label="Immagine successiva"
            className="absolute right-3 top-1/2 -translate-y-1/2 bg-ink/85 text-greige p-2.5 hover:bg-ink transition-colors"
          >
            <ChevronRight size={18} />
          </button>

          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-2">
            {list.map((_, idx) => (
              <button
                key={idx}
                type="button"
                onClick={() => setI(idx)}
                aria-label={`Vai all'immagine ${idx + 1}`}
                className={`h-1.5 rounded-full transition-all ${idx === i ? "w-6 bg-ink" : "w-1.5 bg-darkgrey/50"}`}
              />
            ))}
          </div>

          <span className="absolute top-3 right-3 font-mono2 text-[10px] uppercase tracking-widest bg-ink/85 text-greige px-2 py-1">
            {i + 1} / {list.length}
          </span>
        </>
      )}
    </div>
  );
}
